import {useFindNoOperCommentById, useUpdateComment} from "hooks/queries/non-oper-comment.query"
import {CommentInput, NoneOperationCommentForm} from "pages/dashboard/popup/noneOperation/NoneOperationCommentForm"
import {NoneOperationComment} from "dto/realdevice/none-operation-comment"
import {AxiosError} from "axios"

type props = {
    id: number
    onSuccess: () => void
    onCancel: () => void
}
export default function UpdateNoneOperationComment({id, onSuccess, onCancel}: props) {
    const result = useFindNoOperCommentById(id)
    const updateCommant = useUpdateComment()
    console.log("result", result.data)
    const onSubmit = (value: CommentInput) => {
        console.log("data : ", value)
        const comment: NoneOperationComment = {
            id: id,
            eui: result.data.eui,
            comment: value.comment,
            fromDate: value.fromDate,
            endDate: value.endDate,
        }
        updateCommant.mutate(comment, {
            onSuccess: (data, variables, context) => {
                // console.log("success value : ", data, variables, context)
                onSuccess()
            },
            onError: (err, variables, context) => {
                const error = (err as AxiosError)
                // console.log("error value : ", error, variables, context)
            },
        })
    }
    return (
        <NoneOperationCommentForm
            onSubmit={onSubmit} onCancel={onCancel}
            comment={result.data}
        />
    )
}